import { Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React, { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { completePayroll } from 'services/api/modules/payroll/payroll-summary'
import useNetworkStatus from 'services/hooks/useNetworkStatus'
import { toast } from 'react-toastify'

const SubmissionModal = ({ date, time_id }) => {
  const navigate = useNavigate()
  const { isOffline } = useNetworkStatus()
  const [isModalOpen, setModalOpen] = useState(false)
  const queryClient = useQueryClient()
  const returnDashboard = () => {
    navigate('/app/payroll/dashboard')
    queryClient.invalidateQueries(['activeRun'])
    queryClient.invalidateQueries(['nonActiveRun'])
    queryClient.invalidateQueries(['getHistory'])
    queryClient.invalidateQueries(['historyDropdown'])
  }
  const returnHistoryReport = () => {
    navigate(`/app/payroll/payroll-history/${date?.month}-${date?.year}`, { state: time_id })
  }
  const { refetch } = useQuery(
    ['completePayrollRun', time_id],
    async () => completePayroll(time_id),
    {
      enabled: false,
      onSuccess: () => {
        setModalOpen(true)
      },
    }
  )
  const handleCompletePayrollRun = () => {
    if (isOffline) {
      toast.error('Connection lost. Please reconnect and try again.')
      return
    }

    refetch()
  }
  return (
    <>
      <AdxButton
        variant={'contained'}
        disabled={isOffline}
        sx={{ width: '222px' }}
        onClick={handleCompletePayrollRun}
      >
        Submit payroll
      </AdxButton>
      <AdxInfoModal
        open={isModalOpen}
        muiIcon="check_circle"
        iconColor="positive.main"
        title="Payroll has been submitted"
        subtitle=""
        modalWidth="500px"
        footerButtons
        firstBtnLabel={'View payroll details'}
        firstBtnHandle={returnHistoryReport}
        secondBtnLabel={'Return to dashboard'}
        secondBtnHandle={returnDashboard}
      >
        <Typography align="center" variant="body1" color="light-gray-text.main">
          {`Your regular payroll for the ${date?.month} ${date?.year} period has been successfully submitted.`}
        </Typography>
        <Typography align="center" variant="body1" color="light-gray-text.main">
          You may now submit supporting documents (e.g: Lampiran 1, Form A) on the payroll details
          page.
        </Typography>
        {/* <Box display="flex" flexDirection="column" rowGap={1} width="100%" sx={{ mt: 4 }}>
          <AdxButton variant={'contained'} sx={{ width: '100%' }} onClick={returnHistoryReport}>
            View payroll details
          </AdxButton>
          <AdxButton variant={'outlined'} sx={{ width: '100%' }} onClick={returnDashboard}>
            Return to dashboard
          </AdxButton>
        </Box> */}
      </AdxInfoModal>
    </>
  )
}

export default SubmissionModal
